module.exports = __webpack_public_path__ + "img/logo_koran_jakarta.c0dd4949.png";